import React from "react";
import "./serviceTypeModal.css";
import wellbeing from "../../static/images/wellbeing.svg"
import nutrionist from "../../static/images/nutrionist.svg"
import { getSubDomain } from "../../helpers";
import { pushToDataLayer } from "../../helpers/analytics";
import { ANALYTICS_EVENTS } from "../../Constants";

export function ServiceTypeModal({ serviceTypes, closeModal, handleAppointmentPage }) {

  const handleServiceTypeSelection = (type) => {
    const subDomain = getSubDomain();
    if (subDomain) {
      pushToDataLayer(ANALYTICS_EVENTS.BUTTON_CLICKS.SERVICE_TYPE_BTN, {
        sub_domain: subDomain,
        selected_service_type: type.name,
      });
    }
    handleAppointmentPage(type.code);
  };

  return (
    <div
      className="sh-custom-modal-comp"
      onClick={closeModal}
    >
      <div className="sh-gnrl-modal-inner sh-service-type-modal-inner">
        <div className="sh-gnrl-modal sh-service-type-modal">
          <h3>Select Service Type</h3>
          <div className="service-type-modal-content">
            {Array.isArray(serviceTypes.service_types) && serviceTypes.service_types.length > 0 &&
              serviceTypes.service_types.map((type, index) => {
                return (
                  <div className="type-container"
                    key={index}
                    onClick={() => handleServiceTypeSelection(type)}
                  >
                    <div className="type-name-icon">
                      <img src={`${type.code === 'wellbeing' ? wellbeing : nutrionist}`} />
                      <div className="text-dark type-name">{type.name}</div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ServiceTypeModal/index.js